import { appConfig } from 'modules/app-config';

import { createAxiosInstance } from './api';

const aceApi = createAxiosInstance({ baseURL: appConfig.aceApiBaseUrl });
const aceApiV2 = createAxiosInstance({ baseURL: `${appConfig.aceApiBaseUrl}/v2` });

export { aceApi, aceApiV2 };
